import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DynamicComponentHostDirective } from '../dynamic-component-host.directive';


@NgModule({
  declarations: [DynamicComponentHostDirective],
  imports: [CommonModule],
  exports: [DynamicComponentHostDirective]
})
export class DynamicComponentsModule { }
